// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3HVnh","overflowing":"ReadFullNote_overflowing__16G7L"};